module.exports = __webpack_public_path__ + "static/media/brsrBannerImage2.fdc0d3bf.svg";